
import Vue from 'vue'
import VueRouter from 'vue-router'
import App from './App.vue'

// LightBootstrap plugin
import LightBootstrap from './light-bootstrap-main'

import VeeValidate from 'vee-validate'
Vue.use(VeeValidate)

  // Import component
  import Loading from 'vue-loading-overlay';
  // Import stylesheet
  import 'vue-loading-overlay/dist/vue-loading.css';

  Vue.use(Loading)

import Paginate from 'vuejs-paginate'
Vue.component('paginate', Paginate)

import store from './store/store'

import i18n from './i18n'
 
// router setup
import './services/acl'

import routes from './routes/routes'

import './registerServiceWorker'

import "vue-select/dist/vue-select.css";

import VueConfirmDialog from 'vue-confirm-dialog'
 
Vue.use(VueConfirmDialog)
Vue.component('vue-confirm-dialog', VueConfirmDialog.default)

import { BootstrapVue, ModalPlugin} from 'bootstrap-vue'
Vue.use(BootstrapVue, ModalPlugin)

import VueJsonToCsv from 'vue-json-to-csv'
Vue.use(VueJsonToCsv);
Vue.component('vue-json-to-csv', VueJsonToCsv)

import http  from './services/http'

import { Datetime } from 'vue-datetime'
// You need a specific loader for CSS files
import 'vue-datetime/dist/vue-datetime.css'

Vue.component('datetime', Datetime);

Vue.use(Datetime)

// plugin setup
Vue.use(http)
Vue.use(VueRouter)
Vue.use(LightBootstrap)

// configure router
const router = new VueRouter({
	mode: 'history',

  routes, // short for routes: routes
  linkActiveClass: 'nav-item active',
  scrollBehavior: (to) => {
    if (to.hash) {
      return {selector: to.hash}
    } else {
      return { x: 0, y: 0 }
    }
  }
})

router.beforeEach((to, from, next) => {
	if(to.meta.reqGuest) {
		next()
		return
	}

  if(to.meta.reqAuth && store.getters['auth/isLoggedIn'] && Vue.prototype.$can(to.meta.gate)) {
		next()
		return
	}
	next({ name: 'login', query: { next: to.fullPath } })
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  render: h => h(App),
  router,
  i18n,
  store
})

i18n.locale = localStorage.getItem('lang')

